import { Component, OnInit } from '@angular/core';
import { CarrosselService } from 'src/app/api/module/portal/services/carrossel.service';

@Component({
  selector: 'app-carrossel',
  templateUrl: './carrossel.component.html',
  styleUrls: ['./carrossel.component.scss']
})
export class CarrosselComponent implements OnInit {

  dadosCarrossel: any
  whatsApp: any = "https://api.whatsapp.com/send/?phone=5511994766124&text&type=phone_number&app_absent=0";
  
  constructor(
    private carrosselService: CarrosselService
  ) { }

  ngOnInit(): void {
    this.getDadosCarrossel();
  }

  getDadosCarrossel(){
    this.carrosselService.getCarrosselSite().subscribe(dados => {
      this.dadosCarrossel = dados && dados
      console.log(this.dadosCarrossel)
    })
  }
}
